<template>
  <div class="results-table__cell">
    <span
      class="results-table__cell-base-icon"
      :style="dbImage"
      :title="dbName"
    ></span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { cellMixins } from './mixins'

export default {
  mixins: [cellMixins], // 

  computed: {
    ...mapGetters([
      'currDatabase'
    ]),
    currDb() {
      return this.currDatabase(this.docData[this.cellData.dataFields[0]])
    },
    dbName() {
      return this.currDb ? this.currDb.name : 'База';
    },
    dbImage() {
      return this.currDb? {backgroundImage: `url('${this.currDb.iconUrl}')`}: '';
    },
  }
};
</script>
